import { StringParam, useQueryParam, withDefault } from "next-query-params";
import { JobListSortType } from "../types/client-job-card-list-item";

export const useJobCardListSort = () => {
  const [sort, setSort] = useQueryParam(
    "sort",
    withDefault(StringParam, "most-recent")
  );

  return {
    sort: sort as JobListSortType,
    setSort,
  };
};
